import React from 'react';
import styled from 'styled-components'
import { useSetting } from '../../../shared/hooks/useApi/useSetting';
import { useCheckBeforeMove } from '../../../shared/hooks/useCheckBeforeMove';
import { usePageOwnerIdentityStore } from '../../../shared/store/pageOwnerIdentityStore';
import { useNavigate } from 'react-router-dom';


export interface LeftLogoUsernameProps {
  isHovered: boolean;
}

const LnbLogoUsername: React.FC<LeftLogoUsernameProps> = ({ isHovered }) => {
  const { setting } = useSetting();
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);
  const { getCurrentPage } = useCheckBeforeMove();
  const navigate = useNavigate();

  const handleUsernameClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!pageOwner) return;
    e.stopPropagation();
    if (getCurrentPage().page === 'billboard') return;
    navigate(`/@${pageOwner.handle}/`);
  }

  if (!setting) return null;

  return (
    <LnbLogoUsernameComp $isHovered={isHovered}>
      <Username onClick={(e) => handleUsernameClick(e)}>
        {setting.username}
      </Username>
    </LnbLogoUsernameComp>
  )
}

const LnbLogoUsernameComp = styled.section<{ $isHovered: boolean }>`
  width: 100%;
  height: clamp(30px, 5vh, 70px);
  display: flex;
  align-items: center;
  gap: 4px;
  
  overflow: hidden;
  margin-bottom: clamp(60px, 8vh, 90px);
`;

const Username = styled.div`
  white-space: nowrap;
  text-decoration: none;
  margin-left: 10px;
  cursor: pointer;
  ${({ theme }) => theme.typography.Body_02_1};

  pointer-events: auto;
`;

export default LnbLogoUsername;
